<template>
    <div class="segment-item">
        <!-- Основной элемент сегмента -->
        <div class="segment-parent">
            <!-- Кнопка разворачивания -->
            <button v-if="segment.children && segment.children.length > 0" class="expand-button" @click="toggleExpand">
                <img :src="isExpanded ? '/images/arrow-down.svg' : '/images/arrow-right.svg'" alt="expand" />
            </button>
            <div v-else class="expand-spacer"></div>

            <!-- Кнопка добавления -->
            <button class="btn-add-round" @click="addSegment" :disabled="isSelected">
                <img :src="isSelected ? '/images/circle-check.svg' : '/images/circle-check.svg'" alt="add" />
            </button>

            <!-- Информация о сегменте -->
            <div class="segment-info">
                <div class="segment-title">{{ segment.title }}</div>
                <div v-if="shouldShowDescription" class="segment-description">
                    <div v-for="(line, index) in formattedDescription" :key="index" class="description-line">
                        {{ line }}
                    </div>
                </div>
            </div>
        </div>

        <!-- Дочерние элементы (рекурсивно) -->
        <div v-if="isExpanded && segment.children && segment.children.length > 0" :class="childrenContainerClass">
            <SegmentItem v-for="child in segment.children" :key="child.id" :segment="child" :level="level + 1"
                :expanded-items="expandedItems" :selected="selected"
                :should-show-description="shouldShowDescription" @add-segment="$emit('add-segment', $event)"
                @remove-segment="$emit('remove-segment', $event)" @toggle-expand="$emit('toggle-expand', $event)" />
        </div>
    </div>
</template>

<script>
export default {
    name: "SegmentItem",
    props: {
        segment: {
            type: Object,
            required: true
        },
        level: {
            type: Number,
            default: 0
        },
        expandedItems: {
            type: Set,
            required: true
        },
        // flat array of selected audience ids
        selected: {
            type: Array,
            required: true
        },
        shouldShowDescription: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        isExpanded() {
            return this.expandedItems.has(this.segment.id);
        },

        isSelected() {
            return Array.isArray(this.selected) && this.selected.includes(this.segment.id);
        },

        formattedDescription() {
            if (!this.segment.description) return [];

            return this.segment.description
                .replace(/; -/g, ';\n-')
                .replace(/\. -/g, '.\n-')
                .split('\n')
                .map(line => line.trim())
                .filter(line => line.length > 0);
        },

        childrenContainerClass() {
            const baseClass = 'children-container';
            if (this.level === 0) return baseClass;
            if (this.level === 1) return 'grandchildren-container';
            return 'great-grandchildren-container';
        }
    },
    methods: {
        toggleExpand() {
            this.$emit('toggle-expand', this.segment);
        },

        addSegment() {
            this.$emit('add-segment', this.segment);
        }
    }
};
</script>

<style lang="scss" scoped>
.segment-item {
    border-bottom: 1px solid #f8f9fa;

    &:hover {
        background: #f8f9fa;
    }

    .segment-parent {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 16px;

        .expand-button {
            width: 20px;
            height: 20px;
            background: none;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;

            img {
                width: 12px;
                height: 12px;
                transition: transform 0.2s ease;
            }
        }

        .expand-spacer {
            width: 20px;
            height: 20px;
        }
    }

    .children-container {
        background: #f8f9fa;
        border-left: 2px solid #dee2e6;
        margin-left: 20px;

        .segment-item {
            border-bottom: 1px solid #e9ecef;

            &:last-child {
                border-bottom: none;
            }

            .segment-parent {
                padding-left: 20px;
            }
        }
    }

    .grandchildren-container {
        background: #ffffff;
        border-left: 2px solid #adb5bd;
        margin-left: 20px;

        .segment-item {
            border-bottom: 1px solid #f1f3f4;

            &:last-child {
                border-bottom: none;
            }

            .segment-parent {
                padding-left: 20px;
            }
        }
    }

    .great-grandchildren-container {
        background: #f8f9fa;
        border-left: 2px solid #6c757d;
        margin-left: 20px;

        .segment-item {
            border-bottom: 1px solid #e9ecef;

            &:last-child {
                border-bottom: none;
            }

            .segment-parent {
                padding-left: 20px;
            }
        }
    }
}

.segment-info {
    flex: 1;

    .segment-title {
        font-size: 14px;
        font-weight: 500;
        color: #212529;
        margin-bottom: 0;
    }

    .segment-description {
        font-size: 12px;
        color: #6c757d;
        line-height: 1.4;
        margin-top: 4px;

        .description-line {
            margin-bottom: 4px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>
